import script from "./Chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./Chart.vue?vue&type=script&lang=ts&setup=true"

import "./Chart.vue?vue&type=style&index=0&id=1f8d633e&lang=scss&scoped=true"
import "./Chart.vue?vue&type=style&index=1&id=1f8d633e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8d633e"]])

export default __exports__